"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttributeChangeType;
(function (AttributeChangeType) {
    AttributeChangeType["ADD"] = "ADD";
    AttributeChangeType["EDIT"] = "EDIT";
    AttributeChangeType["REMOVE"] = "REMOVE";
})(AttributeChangeType || (AttributeChangeType = {}));
exports.default = AttributeChangeType;
//# sourceMappingURL=AttributeChangeType.js.map